import { createContext } from 'react';

/**
 * Used by Table.SortableHeaderCell to set icon alignments.
 */
export var TableContext = /*#__PURE__*/createContext({});
export var TableProvider = TableContext.Provider;